import { useRef, RefObject } from "react";
import { useVideoConfig, OffthreadVideo, Audio } from "remotion";
import { VideoSegmentMultiFocusDesignSystemConfig } from "../../VideoSegmentMultiFocus";
import { onVideoFrame } from "../DefaultVideoSegmentMultiFocus";
import { BorderWrapper } from "../utils/borderStyle";
import { getCloudFrontUrl } from "../../../../../../helper/CloudFrontUrlHelper";

const LandscapeFocus: React.FC<VideoSegmentMultiFocusDesignSystemConfig> = ({ startTimestampMS, endTimestampMS, videoURL, spacing, borderRadius, border, borderStyle, framing, designSystem, audioURL }) => {
    const { width, height, fps } = useVideoConfig();
    const resolvedVideoURL = getCloudFrontUrl(videoURL);
    const resolvedAudioURL = audioURL ? getCloudFrontUrl(audioURL) : undefined;

    // We will display a single 16:9 video
    const canvasRefs = [useRef<HTMLCanvasElement>(null)];

    const paddingSize = spacing ? Math.sqrt(width * height) * 0.05 : 0;
    const borderThickness = spacing ? Math.sqrt(width * height) / 150 : 0;

    const totalWidth = (width - paddingSize * 2 - borderThickness * 2);
    const totalHeight = totalWidth * 9 / 16;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-evenly',
                alignContent: 'space-evenly',
                width: '100%',
                height: '100%',
            }}
        >
            <OffthreadVideo
                style={{ opacity: 0, display: 'none' }}
                src={resolvedVideoURL}
                startFrom={startTimestampMS / 1000 * fps}
                endAt={endTimestampMS / 1000 * fps}
                onVideoFrame={(frame) => onVideoFrame(frame, framing[designSystem.canvas.aspectRatio].focusRegions, canvasRefs as RefObject<HTMLCanvasElement>[])}
                muted={Boolean(resolvedAudioURL)}
            />
            {resolvedAudioURL && <Audio src={resolvedAudioURL} />}
            {framing[designSystem.canvas.aspectRatio].focusRegions.map((_, index) => (
                <BorderWrapper
                    key={index}
                    borderStyle={borderStyle}
                    borderThickness={borderThickness}
                    borderRadius={borderRadius}
                >
                    <canvas
                        ref={canvasRefs[index]}
                        width={totalWidth}
                        height={totalHeight}
                        style={{
                            aspectRatio: '16 / 9',
                        }}
                    />
                </BorderWrapper>
            ))}
        </div>
    );
}

export const LandscapeFocusVideoSegment: React.FC<VideoSegmentMultiFocusDesignSystemConfig> = (props) => {
    return (
        <LandscapeFocus {...props} />
    )
}
